module.exports = __webpack_public_path__ + "img/pencil-box-outline.ab360fc.svg";